<template>
      <header>
        <div class="container">
          <div class="datah_left"><a href="https://www.openkylin.top/"><img src="../assets/data_logo.png" /></a></div>
          <div class="datah_right">
            <el-row class="block-col-2 datah_right_lang">
              <el-col :span="12">
                <el-dropdown trigger="click"  @command="changeLang" :hide-on-click="true">
                  <span class="el-dropdown-link">
                    {{$t('okmain.lang')}}
                    <!-- {{lang_default}} -->
                    <i class="el-icon-arrow-down el-icon--right"></i>

                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="cn">中文(简体)</el-dropdown-item>
                    <el-dropdown-item command="en">English</el-dropdown-item>
                    <el-dropdown-item command="zh">中文(繁体)</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-col>
            </el-row>
            <nav class="datah_right_nav">
                 <el-menu :default-active="activeIndex" class="el-menu-demo oknav1" mode="horizontal" :router="true" @select="handleSelect" @click="handleClick">
                <el-menu-item index="/index" ><router-link to="/index">{{$t('okmain.nav1')}}</router-link></el-menu-item>
                <el-menu-item index="/sig"><router-link to="/sig">{{$t('okmain.nav2')}}</router-link></el-menu-item>
                <el-menu-item index=""><a :href="$t('okmain.openkylinweburl')">{{$t('okmain.nav3')}}</a></el-menu-item>
              </el-menu>
            </nav>


            <!-- <div style="width: 100%;">
              <div>
                <div> -->
                  <!-- <span>{{$t('main.message')}}</span> -->
                  <!-- <button @click="changeLang">切换语言</button>
                </div>
              </div>
            </div> -->

            <nav>
              <el-menu :default-active="activeIndex" class="el-menu-demo oknav2" mode="horizontal" @select="handleSelect" menu-trigger="click" :router="true">
                <el-submenu index="">
                  <template slot="title"><img src="../assets/data_menu.png"/></template>
                  <el-menu-item index="/index">{{$t('okmain.nav1')}}</el-menu-item>
                  <el-menu-item index="/number" >{{$t('okmain.nav2')}}</el-menu-item>
                  <el-menu-item index=""><a :href="$t('okmain.openkylinweburl')">{{$t('okmain.nav3')}}</a></el-menu-item>
                 </el-submenu>
              </el-menu>
            </nav>
          </div>
        </div>
      </header>
</template>

<script>
export default {
    name: "Header",
    data() {
        return {
            activeIndex: '',
            lang_default: '中文(简体)',

        }
    },
    watch: {
        '$route' (to, from) {
            // 当路由变化时，更新 activeIndex
            if (to.path.includes('/index')) {
                this.activeIndex = '/index';
            } else if (to.path.includes('/number') || to.path.includes('/sig') || to.path.includes('/personal')) {
                this.activeIndex = '/number';
            }
        }
    },
    methods:{
        handleSelect(key, keyPath) {
      },
      handleClick(tab, event) {
      },
      changeLang(command) {
        this.$router.push({path: this.$route.path, query:{lang:command} }, () => {
          // 重新加载页面
          this.$i18n.locale = command   // 设置当前语言
          // window.location.reload();
        });

        // switch(command){
        //   case 'cn':this.lang_default='中文(简体)';break;
        //   case 'en':this.lang_default='English';break;
        //   case 'zh':this.lang_default='中文(繁体)';break;
        //   default:lang_default='中文(简体)';break;
        // }
    }

    }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Header.vue